"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertBanner = exports.iconColorsMap = void 0;
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_link_1 = require("@carlsberggroup/malty.atoms.link");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_molecules_pagination_1 = require("@carlsberggroup/malty.molecules.pagination");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const layout_json_1 = __importDefault(require("@carlsberggroup/malty.theme.malty-theme-provider/layout.json"));
const malty_utils_helpers_1 = require("@carlsberggroup/malty.utils.helpers");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const AlertBanner_helper_1 = require("./AlertBanner.helper");
const AlertBanner_styled_1 = require("./AlertBanner.styled");
const AlertBanner_types_1 = require("./AlertBanner.types");
exports.iconColorsMap = {
    [AlertBanner_types_1.AlertBannerType.Information]: malty_atoms_icon_1.IconColor.White,
    [AlertBanner_types_1.AlertBannerType.Warning]: malty_atoms_icon_1.IconColor.DigitalBlack,
    [AlertBanner_types_1.AlertBannerType.Error]: malty_atoms_icon_1.IconColor.White,
    [AlertBanner_types_1.AlertBannerType.Success]: malty_atoms_icon_1.IconColor.DigitalBlack
};
const textColorsMap = {
    [AlertBanner_types_1.AlertBannerType.Information]: malty_atoms_text_1.TextColor.White,
    [AlertBanner_types_1.AlertBannerType.Warning]: malty_atoms_text_1.TextColor.DigitalBlack,
    [AlertBanner_types_1.AlertBannerType.Error]: malty_atoms_text_1.TextColor.White,
    [AlertBanner_types_1.AlertBannerType.Success]: malty_atoms_text_1.TextColor.DigitalBlack
};
const iconNameMap = {
    [AlertBanner_types_1.AlertBannerType.Information]: malty_atoms_icon_1.IconName.Information,
    [AlertBanner_types_1.AlertBannerType.Warning]: malty_atoms_icon_1.IconName.Alert,
    [AlertBanner_types_1.AlertBannerType.Error]: malty_atoms_icon_1.IconName.Alert,
    [AlertBanner_types_1.AlertBannerType.Success]: malty_atoms_icon_1.IconName.ItemCheck
};
const AlertBanner = ({ alerts, breakpoint = layout_json_1.default.small['device-max-width'].value, animation, onActiveAlertChange }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const [activeAlert, setActiveAlert] = (0, react_1.useState)(1);
    const [width, setWidth] = (0, react_1.useState)(window.innerWidth);
    const [alertsArray, setAlertsArray] = (0, react_1.useState)(alerts);
    const currentAlert = alertsArray[activeAlert - 1];
    const breakpointNumber = (0, malty_utils_helpers_1.getBreakpointNumber)(breakpoint);
    const isMobile = width < breakpointNumber;
    const [textWrapperSize, setTextWrapperSize] = (0, react_1.useState)(0);
    const alertBannerStyledMessage = (0, react_1.useRef)(null);
    const { showAnimations, triggerYPosition, isBannerTextCompressed, toggleBannerTextCompress } = animation || {
        showAnimations: false,
        triggerYPosition: 0,
        isBannerTextCompressed: false,
        toggleBannerTextCompress: undefined
    };
    const hasMoreThanOneAlert = alertsArray.length > 1;
    const showBottomArea = hasMoreThanOneAlert || !!currentAlert.action;
    const displayContentInWhiteColor = currentAlert.type !== AlertBanner_types_1.AlertBannerType.Warning && currentAlert.type !== AlertBanner_types_1.AlertBannerType.Success;
    const handleToggle = (value) => {
        if (isMobile) {
            toggleBannerTextCompress === null || toggleBannerTextCompress === void 0 ? void 0 : toggleBannerTextCompress(value);
        }
    };
    const showAlertBannerDetails = () => {
        if (isBannerTextCompressed && isMobile) {
            handleToggle(false);
        }
    };
    const setNewAlertBannerDetailsState = (newState) => {
        handleToggle(newState);
    };
    (0, AlertBanner_helper_1.useScrollPosition)(({ currPos }) => {
        const scrollBiggerThanTriggerPosition = () => isMobile && showAnimations && Math.abs(currPos.y) > triggerYPosition;
        if (scrollBiggerThanTriggerPosition() && !isBannerTextCompressed) {
            setNewAlertBannerDetailsState(true);
            return;
        }
        if (!scrollBiggerThanTriggerPosition() && isBannerTextCompressed) {
            setNewAlertBannerDetailsState(false);
        }
    }, [isMobile, showAnimations, isBannerTextCompressed], 200);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const changeMobileTextWrapperSize = () => {
        if (alertBannerStyledMessage.current) {
            setTextWrapperSize(alertBannerStyledMessage.current.clientHeight);
        }
    };
    (0, react_1.useEffect)(() => {
        if (isMobile) {
            changeMobileTextWrapperSize();
        }
    }, [activeAlert, isMobile]);
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };
    const handleOnKeyUp = (action) => ({ key }) => {
        if (key === 'Enter' && action) {
            action();
        }
    };
    const triggerAnimation = () => isBannerTextCompressed || false;
    (0, react_1.useEffect)(() => {
        onActiveAlertChange === null || onActiveAlertChange === void 0 ? void 0 : onActiveAlertChange(currentAlert);
    }, [currentAlert, onActiveAlertChange]);
    if (!alertsArray.length) {
        return null;
    }
    const renderAction = () => {
        if (!currentAlert.action) {
            return null;
        }
        return (react_1.default.createElement(AlertBanner_styled_1.StyledAction, { "data-testid": `${currentAlert.dataQaId}-action-container`, tabIndex: 0, onClick: currentAlert.action, onKeyUp: handleOnKeyUp(currentAlert.action), role: "button", theme: theme, breakpoint: breakpoint },
            react_1.default.createElement(malty_atoms_link_1.Link, { color: displayContentInWhiteColor ? malty_atoms_link_1.LinkColor.White : malty_atoms_link_1.LinkColor.DigitalBlack, linkStyle: malty_atoms_link_1.LinkStyle.MediumSmallBold }, currentAlert.actionName)));
    };
    const handleDismiss = () => {
        if (currentAlert.onDismiss) {
            const newAnnouncementContentArray = alertsArray.filter((item) => item.eid !== currentAlert.eid);
            setAlertsArray(newAnnouncementContentArray);
            if (hasMoreThanOneAlert && activeAlert === alertsArray.length) {
                setActiveAlert(activeAlert - 1);
            }
            return currentAlert.onDismiss();
        }
        return () => null;
    };
    const renderCloseButton = () => (react_1.default.createElement(AlertBanner_styled_1.CloseButtonContainer, { triggerFadeAnimation: triggerAnimation(), "data-testid": `${currentAlert.dataQaId}-close-icon`, onClick: handleDismiss, onKeyUp: handleOnKeyUp(currentAlert.onDismiss), tabIndex: 0, role: "button", "aria-label": "Close button", theme: theme }, currentAlert.dismissible && (react_1.default.createElement(malty_atoms_icon_1.Icon, { className: "inline-AlertBanner-icon", name: malty_atoms_icon_1.IconName.Close, size: malty_atoms_icon_1.IconSize.Medium, color: exports.iconColorsMap[currentAlert.type] }))));
    const renderMessage = () => isMobile ? (react_1.default.createElement(AlertBanner_styled_1.FadeText, { fire: triggerAnimation(), currentElementHeight: textWrapperSize },
        react_1.default.createElement(AlertBanner_styled_1.StyledMessage, { hideText: triggerAnimation(), isMobile: true, ref: alertBannerStyledMessage, theme: theme, color: textColorsMap[currentAlert.type] },
            react_1.default.createElement(malty_atoms_text_1.Text, { textStyle: malty_atoms_text_1.TextStyle.MediumSmallDefault, color: textColorsMap[currentAlert.type] }, currentAlert.message)))) : (react_1.default.createElement(AlertBanner_styled_1.StyledMessage, { hideText: triggerAnimation(), theme: theme, color: textColorsMap[currentAlert.type] },
        react_1.default.createElement(malty_atoms_text_1.Text, { textStyle: malty_atoms_text_1.TextStyle.MediumSmallDefault, color: textColorsMap[currentAlert.type] }, currentAlert.message)));
    const renderMobileActionsContent = () => {
        if (showBottomArea) {
            return (react_1.default.createElement(AlertBanner_styled_1.FadeWrapper, { theme: theme, show: isBannerTextCompressed, "data-testid": "fade-wrapper" },
                react_1.default.createElement(AlertBanner_styled_1.ContentRow, { theme: theme },
                    hasMoreThanOneAlert ? (react_1.default.createElement(malty_molecules_pagination_1.Pagination, { count: alertsArray.length, onChange: (pageNr) => setActiveAlert(Number(pageNr)), currentPage: activeAlert, type: malty_molecules_pagination_1.PaginationType.Compact, isWhite: displayContentInWhiteColor, dataTestId: "alert-banner-pagination" })) : null,
                    renderAction())));
        }
        return null;
    };
    return (react_1.default.createElement(AlertBanner_styled_1.Container, { type: currentAlert.type, theme: theme },
        react_1.default.createElement(AlertBanner_styled_1.ContentRow, { "data-testid": `${currentAlert.dataQaId}-AlertBanner-content`, theme: theme, onClick: showAlertBannerDetails },
            !isMobile && hasMoreThanOneAlert ? (react_1.default.createElement(malty_molecules_pagination_1.Pagination, { dataTestId: "alert-banner-pagination", count: alertsArray.length, onChange: (pageNr) => setActiveAlert(Number(pageNr)), currentPage: activeAlert, type: malty_molecules_pagination_1.PaginationType.Compact, isWhite: displayContentInWhiteColor })) : null,
            react_1.default.createElement(AlertBanner_styled_1.MessageContainer, { theme: theme, applyMarginBottom: !showBottomArea, breakpoint: breakpoint, "data-testid": `${currentAlert.dataQaId}-AlertBanner-message-content` },
                currentAlert.icon ? (react_1.default.createElement(malty_atoms_icon_1.Icon, { name: iconNameMap[currentAlert.type], color: exports.iconColorsMap[currentAlert.type], size: malty_atoms_icon_1.IconSize.Medium })) : null,
                renderMessage(),
                !isMobile && currentAlert.action && renderAction()),
            renderCloseButton()),
        isMobile && renderMobileActionsContent()));
};
exports.AlertBanner = AlertBanner;
//# sourceMappingURL=AlertBanner.js.map